export const GUEST_LIST_KEY = 'GuestLists'

export type GuestListType = 'bookmark' | 'friend'

export interface GuestListData {
    [key: number]: {
        dateAdded: number
    }
}

export interface GuestList {
    skip?: boolean
    friend: GuestListData
    bookmark: GuestListData
}

export const getGuestListSkip = () => {
    const guestList = getGuestList()
    return guestList.skip
}

export const setGuestListSkip = () => {
    try {
        const guestList: GuestList = getGuestList()
        const nextGuestList = {
            ...guestList,
            skip: true,
        }
        localStorage.setItem(GUEST_LIST_KEY, JSON.stringify(nextGuestList))
        return true
    } catch (ex) {
        console.error('[setGuestListSkip] error:', ex)
        return false
    }
}

export const getGuestList = (): GuestList => {
    try {
        const stored = JSON.parse(
            localStorage.getItem(GUEST_LIST_KEY) || '{}',
        ) as GuestList
        return { friend: {}, bookmark: {}, ...stored }
    } catch (ex) {
        console.error('[getGuestList] error:', ex)
        return { friend: {}, bookmark: {} }
    }
}

export const setGuestList = (
    uid: number,
    type: GuestListType,
    remove?: boolean,
): boolean => {
    try {
        const nextGuestList: GuestList = getGuestList()
        if (remove) {
            delete nextGuestList[type][uid]
        } else {
            nextGuestList[type] = {
                ...nextGuestList[type],
                [uid]: { dateAdded: Math.floor(Date.now() / 1000) },
            }
        }
        localStorage.setItem(GUEST_LIST_KEY, JSON.stringify(nextGuestList))
        return true
    } catch (ex) {
        console.error('[setGuestList] error:', ex)
        return false
    }
}

export const clearGuestList = () => {
    try {
        localStorage.removeItem(GUEST_LIST_KEY)
    } catch (ex) {
        console.error('[clearGuestList] error:', ex)
    }
}
